var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnderline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "underline_svg__svg-safari-fix",
  viewBox: "0 0 20 20",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.833 16.667v1.666H4.167v-1.666zm-2.5-5.655a3.333 3.333 0 0 1-4.783 2.834 3.125 3.125 0 0 1-1.883-2.942V4.171H5v6.841a5 5 0 0 0 6.667 4.534A4.88 4.88 0 0 0 15 10.837V4.171h-1.667zm0-6.845H15zm-6.666 0H5z"
})));
export default SvgUnderline;